module.exports = __webpack_public_path__ + "img/processing-07.e6a1399e.gif";